import { FormInput, FormInputMoney } from "@farzoom/common-ui-components";
import { Checkbox, Col, Row } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useContext, useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { LotsSubComponent } from "../lots";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { BgFormType } from "@services/guarantees/types";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { FormInputDateTime } from "@app/common-ui-components/FormInputDateTime";
import { BgFormInput } from "@utils/guaranteeForm/formShema";

type Props = LotsSubComponent & {
  bIdx: number;
};

const AVAILABLE_BG_TYPES = ["returnAdvance", "period", "execution"];

export const BeneficiaryContract = ({ lotIndex, bIdx }: Props) => {
  const classes = useStyles();
  const { control, setValue, clearErrors, unregister } = useFormContext<BgFormInput>();
  const { formDisabled, prefix } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";
  const guarantyTypePrefix = prefix ? `${prefix}.guarantee.type` : "guarantee.type";

  const guaranteeType = useWatch({ control, name: guarantyTypePrefix as "guarantee.type" });
  const isContract = useWatch({
    control,
    name: `${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.concluded`,
    defaultValue: false,
  });

  const clearContractFields = () => {
    unregister(`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.contractNumber`);
    unregister(`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.contractDate`);
    unregister(`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.regNumber`);
    unregister(`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.contractAmount`);

    clearErrors(`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract`);
  };

  const onContractChange = (e: CheckboxChangeEvent) => {
    setValue(
      `${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.concluded`,
      e.target.checked
    );

    if (!e.target.checked) {
      clearContractFields();
    }
  };

  useEffect(() => {
    if (!AVAILABLE_BG_TYPES.includes(guaranteeType || "")) {
      unregister(`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.concluded`);
      clearContractFields();
    }
  }, [guaranteeType]);

  if (!AVAILABLE_BG_TYPES.includes(guaranteeType || "")) return null;

  return (
    <div>
      <Checkbox onChange={onContractChange} checked={isContract as boolean}>
        Контракт заключен
      </Checkbox>
      {isContract && (
        <Row gutter={16}>
          <Col span={6}>
            <FormInput
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.contractNumber`}
              className={classes.input}
              control={control}
              setValue={setValue}
              label="№ контракта"
              required={!formDisabled}
            />
          </Col>
          <Col span={6}>
            <FormInputDateTime
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.contractDate`}
              control={control}
              setValue={setValue}
              label="Дата контракта"
              disabled={formDisabled}
              required={!formDisabled}
            />
          </Col>
          <Col span={6}>
            <FormInput
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.regNumber`}
              className={classes.input}
              control={control}
              setValue={setValue}
              label="Реестровый №"
              required={!formDisabled}
            />
          </Col>
          <Col span={6}>
            <FormInputMoney
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.contract.contractAmount`}
              control={control}
              setValue={setValue}
              label="Сумма контракта"
              controls={false}
              disabled={formDisabled}
              maxLength={25}
              required={!formDisabled}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};
